// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "recorder" + "." + "ae72eecd38b4293d" + ".js";
};